import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_CAMIONES_CALADOS } from '../../../../config/forms'
import CamionesCalados from '../../components/consultas/CamionesCalados'
import * as actions from '../../actions'

class FormCamionesCalados extends Component {
  constructor (props) {
    super(props)
    this.obtenerDatosCamionesCalados = this.obtenerDatosCamionesCalados.bind(this)
    this.resetCamionesCalados = this.resetCamionesCalados.bind(this)
  }

  handleFiltersChange (filters) {
    this.props.updateFiltersincupos(filters)
  }

  handleChangeColumnWidths (columnWidths) {
    this.props.onChangeColumnWidthssincupos(columnWidths)
  }

  handleChangeSorting (sorting) {
    this.props.onChangeSortingsincupos(sorting)
  }

  handleChangeSelection (selection) {
    this.props.onChangeSelectionsincupos(selection)
  }

  obtenerDatosCamionesCalados () {
    // conexion al BE
    this.props.obtenerDatosCamionesCalados()
  }

  resetCamionesCalados () {
    this.props.resetCamionesCalados()
  }

  render () {
    return (
      <div id='text-camiones-calados'>
        <CamionesCalados
          camsCalados={this.props.camsCalados}
          camionesCaladosSelection={this.props.camionesCaladosSelection}
          camionesCaladosSorting={this.props.camionesCaladosSorting}
          camionesCaladosFiltro={this.props.camionesCaladosFiltro}
          obtenerDatosCamionesCalados={this.obtenerDatosCamionesCalados}
          resetCamionesCalados={this.resetCamionesCalados}
          onChangeFilters={this.handleFiltersChange}
          onChangeColumnWidths={this.handleChangeColumnWidths}
          onChangeSorting={this.handleChangeSorting}
          onChangeSelection={this.handleChangeSelection}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  camsCalados: state.calado.camsCalados,
  camionesCaladosFiltro: state.calado.camionesCaladosFiltro,
  camionesCaladosAnchoColumna: state.calado.camionesCaladosAnchoColumna,
  camionesCaladosSorting: state.calado.camionesCaladosSorting,
  camionesCaladosSelection: state.calado.camionesCaladosSelection,
  camsCaladosTotalExp: state.calado.camsCaladosTotalExp,
  camsCaladosTotalCalif: state.calado.camsCaladosTotalCalif,
  camsCaladosTotalPerito: state.calado.camsCaladosTotalPerito
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(
  reduxForm({ form: FORM_CAMIONES_CALADOS })(FormCamionesCalados)
)
